<!-- global-loader.component.html -->
<div class="global-loader d-flex justify-content-center align-items-center" *ngIf="isLoading">
    <mat-spinner diameter="40"></mat-spinner>
  </div>
  
